import messages from './messages';
import { createActionName } from 'utils/actions.util';
const DEFAULT_OPTIONS = {};
class Actions {
  static prefix = '[NOTIFICATIONS]';

  static createActionName = action => createActionName(Actions.prefix, action);

  static ERROR = Actions.createActionName('ERROR');

  static SUCCESS = Actions.createActionName('SUCCESS');

  static WARNING = Actions.createActionName('WARNING');

  static INFO = Actions.createActionName('INFO');

  static GENERAL = Actions.createActionName('GENERAL');

  static error = (message = messages.error.id, options = DEFAULT_OPTIONS) => ({
    type: Actions.ERROR,
    message,
    options,
  });

  static success = (
    message = messages.success.id,
    options = DEFAULT_OPTIONS
  ) => ({
    type: Actions.SUCCESS,
    message,
    options,
  });

  static warning = (message, options = DEFAULT_OPTIONS) => ({
    type: Actions.WARNING,
    message,
    options,
  });

  static info = (message, options = DEFAULT_OPTIONS) => ({
    type: Actions.INFO,
    message,
    options,
  });

  static general = (message, options = DEFAULT_OPTIONS) => ({
    type: Actions.GENERAL,
    message,
    options,
  });
}

export default Actions;
